import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

function loginByQQ(loginManager) {
  loginManager.login({
    iUseQQConnect: window.iUseQQConnect, // 是否使用QQ互联
    oQQConnectParams: {
      appId: '101813972',
      redirect_uri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
    },
  });
  localStorage.curPlatform = 'qq';
}
function loginByWx(loginManager) {
  loginManager.loginByWX({
    appConfig: {
      QQBrowserAppId: '106', // 在QQ浏览器端申请的APPID，保持不变
      WxAppId: 'wxfb66a4e99e630765', // 需要在微信申请openLink权限，
      AppName: '超核玩家公众号', // 业务的中文名称
      scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
      LogoUrl: 'http://ossweb-img.qq.com/images/feiji/web201507/logo.png', // 业务在授权时需要显示的正方形标准Logo，
    },
    userinfoSpan: 'userinfo',
  });
  localStorage.curPlatform = 'wx';
}

export default class LoginBase {
  async initLogin() {
    console.log('LoginBase initLogin begin');
    return await new Promise((resolve) => {
      window.milo.ready(() => {
        console.log('supercore initLogin begin');
        // const appLoginType = window.milo.cookie.get('acctype') || '';
        console.log('Vue.prototype.$actInfo.layout_type', Vue.prototype.$actInfo.layout_type);
        if (Vue.prototype.$actInfo.layout_type === 'c-supercore-page-qqroom') {
          // 当页面为QQ大厅使用QQ-PT登录
          window.iUseQQConnect = 0;
        } else {
          // 其他情况使用QQ-互联登录
          window.iUseQQConnect = 1;
        }
        // window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
        window.need('biz.login', (LoginManager) => {
          LoginManager.init({
            appConfig: {
              gameDomain: 'supercore.qq.com',
              WxAppId: 'wxfb66a4e99e630765',
              scope: 'snsapi_userinfo',
            },
            oQQConnectParams: {
              appId: '101813972',
              redirect_uri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
            },
            iUseQQConnect: window.iUseQQConnect,
          });
          loginManagerInstance = LoginManager;
          console.log('supercore initLogin done instance=', loginManagerInstance);
          resolve();
        });
      });
    });
  }

  async login(params = { loginType: 'qq' }) {
    console.log('LoginBase login|params=', params);
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  }
  async checkLogin(params) {
    console.log('LoginBase checkLogin|params=', params);
    return await new Promise((resolve) => {
      console.log('loginManagerInstance', loginManagerInstance);


      const appid = common.tool.getQueryparams('appid');
      const openid = common.tool.getQueryparams('openid');
      const acctype = common.tool.getQueryparams('acctype');
      const accessToken = common.tool.getQueryparams('access_token');

      if (appid && openid && acctype && accessToken) {
        // 写cookie
        // const cookies = `appid=;openid=3086137608;acctype=qq;access_token=@ZrbIlXNOI`;
        let changeAcctype = acctype;
        if (acctype === 'qq' && accessToken.length > 10) changeAcctype = 'qc';
        if (acctype === 'weixin') changeAcctype = 'wx';
        const cookies = `appid=${appid};openid=${openid};acctype=${changeAcctype};access_token=${accessToken}`;
        console.log('default url pass cookie=', cookies);
        common.tool.setCookies(cookies);
        resolve({
          isLogin: true,
          userInfo: {
            nickName: common.tool.getQueryparams('nickname') || '当前用户'
          },
        });
        return;
      };

      let checkLoginOrCheckRealLogin = 'checkLogin';
      if (window.location.href.indexOf('C_REAL_LOGIN=1') !== -1) {
        checkLoginOrCheckRealLogin = 'checkRealLogin';
      }
      loginManagerInstance[checkLoginOrCheckRealLogin]((userInfo) => {
        console.log('checklogin loginRes= 1.0.20', userInfo);
        // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
        //
        let { curPlatform } = localStorage;
        console.log('checklogin loginRes= 1.0.20 curPlatform from localStorage ', curPlatform);

        if (!curPlatform) {
          curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
        }
        console.log('checklogin loginRes= 1.0.20 curPlatform ', curPlatform);

        if (curPlatform === 'wx') {
          const getUserInfoParam = {
            openid: common.tool.getCookie('openid'),
            access_token: common.tool.getCookie('access_token'),
            lang: 'zh_CN',
          };
          console.log('getUserInfoByWxOpenId=', getUserInfoParam);
          loginManagerInstance.getUserInfoByWxOpenId(getUserInfoParam, (wxUserInfo) => {
            console.log('登录成功，wx用户信息为', wxUserInfo);
            // eslint-disable-next-line no-param-reassign
            userInfo.avatar = wxUserInfo.headimgurl ? `${wxUserInfo.headimgurl}/64` : '';
            // eslint-disable-next-line no-param-reassign
            userInfo.nickName = wxUserInfo.nickname;
            resolve({
              isLogin: true,
              userInfo,
            });
          }, (err) => {
            console.log('获取用户信息失败', err);
          });
        } else {
          let uin = common.tool.getCookie('uin') || '';
          uin = uin.substr(1);
          if (uin.indexOf('0') === 0) {
            uin = uin.substr(1);
          }
          // QQ号不显示 昵称 因为有会有表情文字其是乱码
          // eslint-disable-next-line no-param-reassign
          userInfo.nickName = uin || userInfo.nickname;
          loginManagerInstance.getUserFace((sAvatar) => {
            console.log(' get QQ getUserFace sAvatar ', sAvatar);
            // eslint-disable-next-line no-param-reassign
            userInfo.avatar = typeof sAvatar === 'string' ? sAvatar : sAvatar.userFace;
            console.log(' get QQ Userinfo ', userInfo);
            resolve({
              isLogin: true,
              userInfo,
            });
          });
        }
      }, (error) => {
        if (!sessionStorage.getItem('logouted')) {
          console.log('version 1.0.20 checklogin fail=', error);
          const { isQQ, isWX } = Vue.prototype.$platform;
          console.log('.isWX = ', isWX);
          console.log('.isQQ = ', isQQ);
          const gameType = Vue.prototype.$actInfo.game_type;
          //  微信在端游的时候不拉去分享
          console.log('gameType from state= ', gameType);
          console.log('Vue.prototype.$actInfo ', Vue.prototype.$actInfo);
          // 默认端游不进行微信登录
          isQQ && loginByQQ(loginManagerInstance);
          // eslint-disable-next-line camelcase
          isWX && gameType !== 1 && loginByWx(loginManagerInstance);
          console.log('gameType =', gameType, 'gameType === 1 是端游 默认端游不进行微信登录');
          resolve({
            isLogin: false,
            userInfo: {},
          });
        } else {
          resolve({
            isLogin: false,
            userInfo: {},
          });
        }
      });
    });
  }
  async logout(params) {
    console.log('LoginBase logout|params=', params);
    await loginManagerInstance.logout({
      logoutCallback: () => {
        // ios存在登出链接地址异常问题
        sessionStorage.setItem('logouted', 'true');
        const url = window.location.href.split('?')[0];
        window.location.href = url;
      },
    });
  }
}
